export default __webpack_public_path__ + "static/media/icon_disclosure-circle-plus.b54d2629.svg";